<template>
<v-dialog id="demo-request-container" class="border-radius-15 modal-class" persistent  v-model="open" attach="#app-container" content-class="demo-dialog-active" hide-overlay>
  <v-card color="rgba(0, 0, 0, 0.9)" class="border-radius-15">
    <v-container class="text-xs-center pa-0 mb-3">
      <v-card-text>
        <p class="text-xs-center white--text fs-24 mt-2 mb-0 bebas">Application Demonstration</p>
      </v-card-text>

      <v-layout class="mt-1" column align-center>
        <v-flex d-flex align-center justify-center>
          <v-flex xs10 class="text-xs-center">

            <p class=" white--text fs-12 mb-0 prestige">We suggest working through the application demo to get familiar with all the functionality.</p>
          </v-flex>

        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-flex class="bebas" light d-flex text-xs-center justify-center align-center mx-3>
        <v-flex xs6 mx-2 class="black--text">

          <v-btn block class="border-radius-5" color="white black--text" @click="finishDemoRequest">skip demo</v-btn>
        </v-flex>
        <v-flex xs6 mx-2>

          <v-btn block class="border-radius-5" color="white black--text" @click="gotoAppDemo">go-to demo</v-btn>
        </v-flex>
      </v-flex>

    </v-container>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: 'demo-request-container',
  props: {
    open: {
      type: Boolean
    }
  },
  methods: {
    gotoAppDemo() {
      this.$store.dispatch('setDemoRequest', false)
      this.$router.push('app-demo')
    },
    finishDemoRequest() {
      this.$store.dispatch('setDemoRequest', false)
      this.$router.push('tour')
    },
  }
}
</script>

<style scoped lang="stylus">

</style>
